import React, { useState, useEffect , useContext } from "react";
// import "../styles/BusquedaTiendaV2.css";
import SearchInput from "./SearchInputTienda";
import SearchResults from "./SearchResultsTienda";
import { getTodasLasTiendas } from './getData';
import { getTodasLasTiendasConServicios } from './getData';
import { FormContext } from "../context/FormContext"; // Importar el contexto
// import { getTodasLasTiendas } from "./mockApi";

const BusquedaTiendaV2 = ({ actualizarMapaCenter, onProgramarExamen }) => {
  const { formData } = useContext(FormContext);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredResults, setFilteredResults] = useState([]);

  const obtenerCoordenadas = async (direccion) => {
    const direccionModificada = direccion.replace(/\s+/g, "+");
    const apiKey = `${process.env.REACT_APP_API_KEY_GOOGLE}`; // Reemplaza con tu API Key de Google
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${direccionModificada}&key=${apiKey}`;

    // URL para obtener coordenadas de Google Maps API
    // console.log("url", url);
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.status === "OK" && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        // Coordenadas obtenidas de Google Maps API
        // console.log("Coordenadas: ", lat, lng);
        return { lat, lng };
      } else {
        // Error: no se encontraron coordenadas para la dirección
        console.error("No se encontraron coordenadas para esta dirección.");
        return null;
      }
    } catch (error) {
      // Error al obtener coordenadas de Google Maps API
      console.error("Error al obtener las coordenadas:", error);
      return null;
    }
  };

  const handleSearch = async (query) => {
    setLoading(true);
    try {
      const tiendas = await getTodasLasTiendasConServicios(query);
      const tiendasConServicio = tiendas?.data?.filter(tienda => tienda.servicio !== null) || [];
      setResults(tiendasConServicio);

      if (tiendas.length > 0) {
        
        const direccionCompleta = `${tiendas[0].direccion}, ${tiendas[0].ubicacion}`;
        const coordenadas = await obtenerCoordenadas(direccionCompleta);

        if (coordenadas) {
          actualizarMapaCenter(coordenadas);
        }
      }
    } catch (error) {
      // Error al buscar tiendas desde la API
      console.error("Error al buscar tiendas:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSearch(""); // Llamamos la función con query vacío para traer todas las tiendas
  }, []);
  

  const handleHover = async (result) => {
 
  
    if (result.cfg_latitud && result.cfg_longitud) {
      // Coordenadas originales de la tienda seleccionada
      // console.log("Valores originales de las coordenadas:", {
      //   lat: result.cfg_latitud,
      //   lng: result.cfg_longitud,
      // });
  
      // Reemplazar comas por puntos antes de convertir a número
      const lat = parseFloat(result.cfg_latitud.replace(",", "."));
      const lng = parseFloat(result.cfg_longitud.replace(",", "."));
  
  
  
      if (!isNaN(lat) && !isNaN(lng)) {
        const coordenadas = { lat, lng };
        actualizarMapaCenter(coordenadas);
      } else {
        // Error: coordenadas no válidas después del procesamiento
        console.error("Las coordenadas no son números válidos después de parsear:", {
          lat,
          lng,
        });
      }
    } else {
      // Advertencia: coordenadas no disponibles en el objeto tienda
      console.warn(
        "Las coordenadas no están disponibles o tienen valores inesperados en el objeto `result`."
      );
    }
  };
  
  



  const handleSelect = (result) => {
    onProgramarExamen(result);
  };

  return (
    <div className="col-sm-6 pads0 store-selector-container">
      <div className="row">
        <div className="col-12 store-selector-finder">
          <h6 className="h4-less mb20-768 text-sm-start text-center">
            <i className="fa fa-map-marker fa-lg"></i>&nbsp; Encuentra la tienda {formData?.cadena} más cercana
          </h6>
          <SearchInput onSearch={handleSearch} tiendasCantidad={filteredResults.length} />
        </div>
        {loading ? (
          <p className="text-center">Buscando...</p>
        ) : (
          <SearchResults filteredResults={filteredResults}
                        setFilteredResults={setFilteredResults}
                        results={results} 
                        onHover={handleHover} 
                        onSelect={handleSelect} />
        )}
      </div>
    </div>
  );
};

export default BusquedaTiendaV2;
